import Backbone from 'backbone'

var ScoringTypeModel = Backbone.Model.extend(/** @lends ScoringTypeModel.prototype */{

	urlRoot: 'api/admin/scoring-types'

})

export default ScoringTypeModel

ScoringTypeModel.__filename__ = 'admin/scoring-types/scoring-type-model.js'
